import { render, staticRenderFns } from "./ServiceJoinStep2Contentsogind.vue?vue&type=template&id=39804822"
import script from "./ServiceJoinStep2Contentsogind.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep2Contentsogind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39804822')) {
      api.createRecord('39804822', component.options)
    } else {
      api.reload('39804822', component.options)
    }
    module.hot.accept("./ServiceJoinStep2Contentsogind.vue?vue&type=template&id=39804822", function () {
      api.rerender('39804822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep2Contentsogind.vue"
export default component.exports